import magnifiAPIInstance from "./apiInstance";

export const onedriveAPIs = {
  initiateAuth: ({ entityId }) => magnifiAPIInstance.get(`/api/v3/integration/onedrive/${entityId}}/auth/initiate`),
  getActiveIntegration: ({ entityId }) => magnifiAPIInstance.get(`/api/v3/integration/onedrive/${entityId}/active`),
  deactivateIntegration: ({ entityId }) =>
    magnifiAPIInstance.delete(`/api/v3/integration/onedrive/${entityId}/deactivate`),
  handleCallback: ({ entityId, code }) =>
    magnifiAPIInstance.post(`/api/v3/integration/onedrive/${entityId}/auth/callback`, { code }),
  uploadToOnedrive: ({ payload }) => magnifiAPIInstance.post(`/api/v3/integration/onedrive/upload`, payload),
};
